import { By } from 'selenium-webdriver';
import { DriverLike, register } from '@oracle/oraclejet-webdriver';
import { InputNumberWebElement } from './InputNumberWebElement';
export { InputNumberWebElement };

/**
 * Retrieve an instance of [InputNumberWebElement](../classes/InputNumberWebElement.html).
 * @example
 * ```javascript
 * import { findInputNumber } from '@oracle/oraclejet-core-pack/webdriver';
 * const el = await findInputNumber(driver, By.id('my-oj-c-input-number'));
 * ```
 * @param driver A WebDriver/WebElement instance from where the element will be
 * searched. If WebDriver is passed, the element will be searched globally in the
 * document. If WebElement is passed, the search will be relative to this element.
 * @param by The locator with which to find the element
 */
export async function findInputNumber(driver: DriverLike, by: By): Promise<InputNumberWebElement> {
  const webEl = await driver.findElement(by);
  // Check that the element is of type InputNumberWebElement
  if (!(webEl instanceof InputNumberWebElement)) {
    const tagName = await webEl.getTagName();
    let supplemental = '';
    if (webEl.constructor.name === 'InputNumberWebElement') {
      supplemental = 'You likely have multiple installations of this package.';
    }
    throw Error(
      `findInputNumber(${by}) created ${webEl.constructor.name} for <${tagName}>, but expected ${InputNumberWebElement.name}. ${supplemental}`
    );
  }
  return webEl;
}

register('oj-c-input-number', InputNumberWebElement);
